import { medicoAgenda } from '../../helpers/agenda/medicos';

export const CFG = {
  internados: {
    convenios: [
      29,
      32,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      53,
      55,
      57,
      59,
      63,
      84,
      97,
      701,
      705,
      720,
      731,
      806,
    ],
    procedimentos: [11, 12, 13, 14],
  },
  ambulatorio: {
    convenios: [27],
    procedimentos: [11],
  },
  mac: {
    convenios: [900, 910],
    procedimentos: [1, 3, 4, 11],
  },
  cross: {
    convenios: [804],
    procedimentos: [11],
  },
};

export const PROCEDIMENTOS_U = [
  1,
  2,
  3,
  4,
  6,
  7,
  11,
  12,
  13,
  15,
  17,
  712,
  713,
  714,
  801,
  810,
];

export const CONVENIOS_U = [14, 65, 69, 70, 900, 910];

export const medicosSorted = medicoAgenda
  .slice(0, 12)
  .sort((a, b) => a.medico.localeCompare(b.medico));
